import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import PageNotFound from "../pages/PageNotFound";
import {
  getChannelListThunk,
  getUserInChannelByChannelIdThunk,
  setAddUserInChannel,
  setChannelCreateLoader,
  setConnectedUserListReducer,
  setMessageReducer,
} from "../slices/userSlice";
import toastMessage from "../utils/toastMessage";
import createWebSocket from "../utils/web-socket";
import { ProtectedRoute } from "./ProtectedRoute";
import {
  ADMIN_NOT_APPROVED,
  ALL_PROTECTED_ROUTES,
  ALL_PUBLIC_ROUTES,
  TALENT_NOT_APPROVED,
} from "./routes_constant";
import { getAllNotification } from "../slices/socketSlice";
import WelcomePage from "../pages/WelcomePage";

const AllRoutes = ({ showAlert, setShowAlert }) => {
  const dispatch = useDispatch();
  const username = useSelector((state) => state.auth.username);
  const user = useSelector((state) => state.user.userAttributes);
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const messagesObj = useSelector((state) => state.user.messagesObj);
  const newMsgDetailObj = useSelector((state) => state.user.newMsgDetailObj);

  const userAllFormsDetails = useSelector(
    (state) => state.user.userAllFormsDetails
  );
  console.log("🚀 ~ AllRoutes ~ userAllFormsDetails:", userAllFormsDetails);
  const basicInfoData = userAllFormsDetails.find(
    (data) => data.SK === "Profile#BasicInfo"
  );
  console.log("🚀 ~ AllRoutes ~ basicInfoData:", basicInfoData);
  const handleNewMessageReceived = (messageEvent) => {
    console.log("Received message event: ", messageEvent);
    const newMsg = JSON.parse(messageEvent.data);
    console.log(newMsg, " = newMsgBody");
    if (newMsg?.type == "create-channel") {
      console.log("Hahahahahahahahahahahahahahaha");
      if (newMsg?.success) {
        toastMessage(newMsg.message, "success");
        dispatch(
          setChannelCreateLoader({ load: false, isChannelCreated: true })
        );
      } else {
        toastMessage(newMsg.message, "error");
        dispatch(
          setChannelCreateLoader({ load: false, isChannelCreated: false })
        );
      }
    } else if (newMsg?.type === "new connection") {
      dispatch(setConnectedUserListReducer([newMsg?.ConnectedUser?.PK]));
    } else if (newMsg?.type === "user-added-in-channel") {
      toastMessage(newMsg.message, "success");
      dispatch(
        setAddUserInChannel({
          loader: false,
          isAdded: true,
          // channelId: newMsg.channelId,
          // userIds: newMsg.userIds,
        })
      );
      dispatch(getUserInChannelByChannelIdThunk(newMsg.channelId)).unwrap();
    } else if (newMsg?.type === "you-added-in-a-channel") {
      toastMessage(newMsg.message, "success");
      dispatch(getChannelListThunk());
    } else if (newMsg?.type === "removed-from-channel") {
      toastMessage(newMsg.message, "success");
      dispatch(getChannelListThunk());
    } else {
      console.log("newMsgBody:created:before");
      dispatch(setMessageReducer({ newMsg }));
    }
    if (newMsg?.type === "sme-request") {
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 5000);
    }

    // let messages = [];
    // console.log(messagesObj[newMsg.senderId], " = messagesObj[newMsg.senderId], ", messagesObj, " = messagesObj");
    // if(messagesObj[newMsg.senderId]){
    //   // messages.push(...messagesObj[newMsg.senderId]);
    //   messages = [...messagesObj[newMsg.senderId]];
    // }
    // messages.push(newMsg);
    // console.log(messages, " = messagesssssssssssssssss");
    // dispatch(setMessageReducer({ userId: newMsg.senderId, messages }));
    // const newMsgDetail = { ...newMsgDetailObj }
    // const messageCounts = (newMsgDetail[newMsg.senderId] || 0) + 1;
    // newMsgDetail[newMsg.senderId] = messageCounts
    // console.log(newMsgDetail, " = newMsgDetailObj:before save");
    // dispatch(setMessageDetailsReducer({ messageCounts: newMsgDetail }));
  };

  useEffect(() => {
    try {
      if (user?.sub && isAuthenticated) {
        dispatch(getAllNotification());
        const { webSocket, cleanup } = createWebSocket(
          user?.sub,
          handleNewMessageReceived,
          dispatch
        );

        return cleanup;
      }
    } catch (error) {
      console.error("Error creating WebSocket connection:", error);
    }
  }, [isAuthenticated, dispatch, user]);

  // const isTalentApproved =
  //   (basicInfoData?.AssignSME && basicInfoData?.AdminApproved === "approved") ||
  //   (!basicInfoData?.AssignSME && !basicInfoData?.IsTalentApprove);

  // const isTalentApproved =
  //   basicInfoData?.AdminApproved === "approved" ||
  //   !basicInfoData?.IsTalentApprove;
  const isTalentApproved =
  basicInfoData?.AdminApproved === "approved" ||
  (!basicInfoData?.AdminApproved && !basicInfoData?.IsTalentApprove);
  console.log("🚀 ~ AllRoutes ~ isTalentApproved:", isTalentApproved)

  const isAdminRejected = basicInfoData?.AdminApproved == "rejected";
  console.log("🚀 ~ AllRoutes ~ isAdminRejected:", isAdminRejected)

  const isSmeApproved =
  basicInfoData?.AdminApproved && basicInfoData?.AdminApproved === "pending";
  console.log("🚀 ~ AllRoutes ~ isSmeApproved:", isSmeApproved)
  // const isSmeApproved =
  //   (basicInfoData?.SmeApproved == "pending" &&
  //     basicInfoData?.AdminApproved == "pending") ||
  //   (basicInfoData?.SmeApproved == "approved" &&
  //     basicInfoData?.AdminApproved == "pending");

  return (
    <Routes>
      {ALL_PUBLIC_ROUTES?.map((route) => {
        let Component = route.component;
        return (
          <Route
            key={route.path}
            path={route.path}
            element={<Component {...route.props} />}
          />
        );
      })}
      {isAdminRejected &&
        ADMIN_NOT_APPROVED?.map((route) => {
          console.log("🚀 ~ ADMIN_NOT_APPROVED?.map ~ route:", route);
          return (
            <Route
              key={route.path}
              path={route.path}
              element={<route.component />}
            />
          );
        })}
      {isSmeApproved &&
        TALENT_NOT_APPROVED?.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={<ProtectedRoute Component={route.component} />}
          />
        ))}
      {isTalentApproved &&
        ALL_PROTECTED_ROUTES?.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={<ProtectedRoute Component={route.component} />}
          />
        ))}
      {/* {!isTalentApproved
        ? ADMIN_NOT_APPROVED?.map((route) => (
            <Route
              key={route.path}
              path={route.path}
              element={<route.component />}
            />
          ))
        : isTalentApproved
        ? ALL_PROTECTED_ROUTES?.map((route) => (
            <Route
              key={route.path}
              path={route.path}
              element={<ProtectedRoute Component={route.component} />}
            />
          ))
        : TALENT_NOT_APPROVED?.map((route) => (
            <Route
              key={route.path}
              path={route.path}
              element={<ProtectedRoute Component={route.component} />}
            />
          ))} */}
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};

export default AllRoutes;
